import type { ReactNode } from "react";
import type { TranslationKey } from "../lib/i18n";
import { useConfig } from "../state/config-context";

export function ComingSoonPage({ titleKey }: { titleKey: TranslationKey }): ReactNode {
  const { t } = useConfig();
  return (
    <section className="page" aria-labelledby="module-title">
      <header className="page__header">
        <h1 id="module-title">{t(titleKey)}</h1>
        <p className="muted">{t("comingSoon.body")}</p>
      </header>
      <div className="placeholder-card" aria-hidden="true">
        <span className="placeholder-card__dot" />
        <span className="placeholder-card__dot" />
        <span className="placeholder-card__dot" />
      </div>
    </section>
  );
}
